import { usePeopleStore } from '@/store';

export const setTab = (tabIndex: number): void => {
	const { setCurrentTab } = usePeopleStore.getState();
	setCurrentTab(tabIndex);
};

export const getTab = (): number => {
	const currentTab = usePeopleStore((state) => state.currentTab);
	return currentTab;
};
